import { createContext, useContext } from 'react'

export const SendQuestionnaireContext = createContext<any>({})

export const useInvitePatientContext = () => {
  const context = useContext(SendQuestionnaireContext)
  return context
}
